var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,40h-32c-0.717,0 -1.377,-0.383 -1.734,-1.004c-0.356,-0.621 -0.354,-1.385 0.007,-2.004l16,-28c0.358,-0.614 1.016,-0.992 1.727,-0.992c0.711,0 1.369,0.378 1.728,0.992l16,28c0.361,0.619 0.363,1.383 0.007,2.004c-0.356,0.621 -1.019,1.004 -1.735,1.004z",
    fill: "#ffe70d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,34.142c0,-0.269 0.047,-0.515 0.143,-0.746c0.094,-0.228 0.229,-0.426 0.403,-0.592c0.171,-0.168 0.382,-0.299 0.624,-0.393c0.244,-0.092 0.518,-0.141 0.824,-0.141c0.306,0 0.582,0.049 0.828,0.141c0.25,0.094 0.461,0.225 0.632,0.393c0.175,0.166 0.31,0.364 0.403,0.592c0.096,0.231 0.143,0.477 0.143,0.746c0,0.27 -0.047,0.516 -0.143,0.74c-0.094,0.225 -0.229,0.419 -0.403,0.588c-0.171,0.166 -0.382,0.296 -0.632,0.392c-0.246,0.092 -0.522,0.138 -0.828,0.138c-0.307,0 -0.58,-0.046 -0.824,-0.139c-0.242,-0.096 -0.453,-0.226 -0.624,-0.392c-0.175,-0.169 -0.31,-0.363 -0.403,-0.588c-0.096,-0.224 -0.143,-0.47 -0.143,-0.739M25.48,30h-2.973l-0.421,-12h3.814z",
    fill: "#131f2a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Error);
export default __webpack_public_path__ + "static/media/icons8-error.23323951de722192b1c50d6490dd7faf.svg";
export { ForwardRef as ReactComponent };